import moment from 'moment';
import fecha from 'fecha';

export default {
  computed: {
    currentDate() {
      return fecha.format(Date.now(), 'YYYY/MM/DD HH:mm');
    },
  },

  methods: {
    parseDateTime(dateTime) {
      return moment(dateTime, ['x', 'YYYY-MM-DDTHH:mm:ss.SSSZ']);
    },

    formatDate(dateTime) {
      const parsedDate = this.parseDateTime(dateTime);
      if (parsedDate.isBefore(moment().subtract('1', 'week'))) {
        return parsedDate.format('YYYY/MM/DD');
      }
      return moment.duration(-(Date.now() - parsedDate)).humanize(true);
    },

    formatDateShort(dateTime, includeTime = false) {
      const parsedDate = this.parseDateTime(dateTime);
      let dateFormat = 'YYYY/MM/DD';
      if (includeTime) dateFormat += ' HH:mm';
      return parsedDate.format(dateFormat);
    },

    formatDateLong(dateTime) {
      const parsedDateTime = this.parseDateTime(dateTime);
      return parsedDateTime.format('dddd, MMMM Do YYYY, HH:mm');
    },
  },
};
